// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__i1ggf","small":"checkbox_small__uamZW","large":"checkbox_large__0f6G0","labeled":"checkbox_labeled__E3x69","disabled":"checkbox_disabled__4MRXi"};